import React, { useEffect, useState, useRef } from "react";
import { RiArrowDownSFill, RiDeleteBin6Line } from "react-icons/ri";
import { IoIosSearch } from "react-icons/io";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import app from "../Firebase";
import unitysceen from "../assests/images/unitysceen.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function EditCategoryForm({ editPopup, setEditPopup }) {
  // Form field states
  const MASTER_CATEGORY_LIST = [
    "Architecture",
    "Characters",
    "Vehicles",
    "Props",
    "Environment",
    "Animals",
    // --- Add any other default categories you want here ---
  ];
  const [companyname, setCompanyname] = useState("");
  const [category, setCategory] = useState("");
  const [which_type, setWhich_type] = useState("");
  const [platform, setPlatform] = useState("");
  const [access, setAccess] = useState([]); // Single source of truth for assigned emails

  // File upload states
  const [thumbnail, setThumbnail] = useState(undefined);
  const [model, setModel] = useState(undefined);
  const [selectedImage, setSelectedImage] = useState(null);
  const [thumbnailPerc, setThumbnailPerc] = useState(0);
  const [modelPerc, setModelPerc] = useState(0);
  const [inputs, setInputs] = useState({});

  // Data & UI states
  const [user, setUser] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchUserTerm, setSearchUserTerm] = useState("");
  const [selectAllChecked, setSelectAllChecked] = useState(false);

  // Dropdown states
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenCompany, setDropdownOpenCompany] = useState(false);

  // Dropdown content states
  const [customCategory, setCustomCategory] = useState("");
  const [uniqueCategories, setUniqueCategories] = useState([]);
  const [filterCategoryData, setFilterCategoryData] = useState([]);
  const [customCompanyname, setCustomCompanyname] = useState("");
  const [uniqueCompanynames, setUniqueCompanynames] = useState([]);
  const [filterCompanyData, setFilterCompanyData] = useState([]);

  // Refs
  const dropdownRef = useRef(null);
  const categoryDropdownRef = useRef(null);
  const companyDropdownRef = useRef(null);

  // Pre-fill form with existing data
  useEffect(() => {
    if (editPopup) {
      setCompanyname(editPopup.companyname || "");
      setCategory(editPopup.category || "");
      setWhich_type(editPopup.which_type || "");
      setPlatform(editPopup.platform || "");
      setAccess(editPopup.access || []);
    }
  }, [editPopup]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [userRes, videoRes] = await Promise.all([
          axios.get(`${Constant.BASE_URL}/user/get`),
          axios.get(`${Constant.BASE_URL}/model/get`),
        ]);

        if (userRes.data?.admins) setUser(userRes.data.admins);

        const allVideos = videoRes.data?.videos || (Array.isArray(videoRes.data) ? videoRes.data : []);
        setVideos(allVideos);

        // --- Logic to combine master list with database categories ---
        const categoriesFromModels = allVideos.map(item => item.category).filter(Boolean);
        const combinedUniqueCatArray = Array.from(
          new Set([...MASTER_CATEGORY_LIST, ...categoriesFromModels])
        ).sort();
        const categories = combinedUniqueCatArray.map((cat, i) => ({ id: i, category: cat }));
        setUniqueCategories(categories);
        // --- End of new logic ---

        const companies = Array.from(new Set(allVideos.map(item => item.companyname))).map((comp, i) => ({ id: i, companyname: comp }));
        setUniqueCompanynames(companies);
        
      } catch (error) {
        console.error("Error fetching data:", error);
        toast.error("Failed to load initial data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []); // This should only run once, so the empty dependency array is correct.


  // Close dropdowns on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpenfilter(false);
      }
      if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
      if (companyDropdownRef.current && !companyDropdownRef.current.contains(event.target)) {
        setDropdownOpenCompany(false);
      }
    }
    if (isDropdownOpenfilter || dropdownOpen || dropdownOpenCompany) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpenfilter, dropdownOpen, dropdownOpenCompany]);

  const handleCloseEdit = () => setEditPopup(null);

  

  const uploadFile = (file, fileType) => {
    const storage = getStorage(app);
    const folder = fileType === "thumbnailUrl" ? "thumbnail/" : "model/";
    const fileName = new Date().getTime() + file.name;
    const storageRef = ref(storage, folder + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);
    uploadTask.on("state_changed", (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      fileType === "thumbnailUrl" ? setThumbnailPerc(Math.round(progress)) : setModelPerc(Math.round(progress));
    }, (error) => console.log(error), () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        setInputs((prev) => ({ ...prev, [fileType]: downloadURL }));
      });
    });
  };

  useEffect(() => { if (model) uploadFile(model, "modelUrl"); }, [model]);
  useEffect(() => { if (thumbnail) uploadFile(thumbnail, "thumbnailUrl"); }, [thumbnail]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size <= 200 * 1024) {
        setThumbnail(file);
        setSelectedImage(URL.createObjectURL(file));
      } else {
        toast.error("Please select an image below 200 KB.");
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault();
  //   try {
  //     if (thumbnail && thumbnailPerc < 100) return toast.warn("Wait for thumbnail upload.");
  //     if (model && modelPerc < 100) return toast.warn("Wait for model file upload.");

  //     const updateData = {
  //       category, which_type, companyname, access, platform,
  //       modelname: model ? model.name : editPopup.modelname,
  //       model: inputs.modelUrl || editPopup.model,
  //       thumbnail: inputs.thumbnailUrl || editPopup.thumbnail,
  //     };

  //     const response = await axios.put(`${Constant.BASE_URL}/model/update/${editPopup._id}`, updateData);

  //     // ✅ CORRECTED: Check for status code 200 for success
  //     if (response.status === 200) {
  //       toast.success("Model updated successfully!");
  //       handleCloseEdit();
  //     } else {
  //       toast.error(response.data.error || "Update failed.");
  //     }
  //   } catch (error) {
  //     console.error("Error updating:", error);
  //     toast.error("An error occurred during update.");
  //   }
  // };

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      if (thumbnail && thumbnailPerc < 100) return toast.warn("Wait for thumbnail upload.");
      if (model && modelPerc < 100) return toast.warn("Wait for model file upload.");

      // 1. Get the token from local storage
      const token = localStorage.getItem('token');
      if (!token) {
        toast.error("You are not authenticated. Please log in again.");
        return;
      }

      const updateData = {
        category, which_type, companyname, access, platform,
        modelname: model ? model.name : editPopup.modelname,
        model: inputs.modelUrl || editPopup.model,
        thumbnail: inputs.thumbnailUrl || editPopup.thumbnail,
      };

      // 2. Add the headers object to your axios request
      const response = await axios.put(
        `${Constant.BASE_URL}/model/update/${editPopup._id}`, 
        updateData,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );

      if (response.status === 200) {
        toast.success("Model updated successfully!");
        handleCloseEdit();
      } else {
        toast.error(response.data.error || "Update failed.");
      }
    } catch (error) {
      console.error("Error updating:", error);
      // Check for specific authorization errors
      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        toast.error("Authorization failed. Please log in again.");
      } else {
        toast.error("An error occurred during update.");
      }
    }
  };
  const handleCheckboxChanged = (email) => {
    setAccess((prevAccess) =>
      prevAccess.includes(email)
        ? prevAccess.filter((e) => e !== email)
        : [...prevAccess, email]
    );
  };
  
  const handleSelectAllChanged = () => {
    const newSelectAllState = !selectAllChecked;
    setSelectAllChecked(newSelectAllState);
    setAccess(newSelectAllState ? user.map(item => item.email) : []);
  };
  
  const filteredUsers = user.filter(u => u.email.toLowerCase().includes(searchUserTerm.toLowerCase()));

  const handleCategorySelect = (item) => { setCategory(item.category); setDropdownOpen(false); };
  const handleCompanyNameSelect = (item) => { setCompanyname(item.companyname); setDropdownOpenCompany(false); };
  
  return (
    <div className="popup-formmodel">
      <div className="flex flex-col items-center justify-center px-10 py-6 bg-white rounded-md w-fit h-fit">
        <h1 className="text-lg font-semibold"> Edit Model</h1>
        <div className="h-[2px] w-full bg-[#959595] mt-0" />
        <form onSubmit={handleUpdate}>
          <div className="flex flex-row items-center justify-between gap-16 px-4 mt-8">
            <div className="flex flex-col items-center gap-6">
              <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                  <div className="pt-2 text-xs font-bold">Thumbnail :</div>
                  <div className="h-[1px] min-w-full bg-[#959595a0]" />
                </div>
                <div className="flex items-center mx-2 justify-center h-[110px]">
                  <label htmlFor="thumbnail" className="cursor-pointer">
                    <img alt="upload" src={selectedImage || editPopup.thumbnail} className="w-32 h-24 object-cover" />
                  </label>
                  <input id="thumbnail" type="file" accept="image/*" className="hidden" onChange={handleImageChange} />
                </div>
                <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                  <div className="h-[2px] min-w-full bg-[#959595a0]" />
                  <div className="text-center text-[#959595a0] text-xs truncate px-1">
                    {thumbnail?.name || "Upload new thumbnail"}
                  </div>
                </div>
                {thumbnailPerc > 0 && (
                  <div className="w-full h-2"><div className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257]" style={{ width: `${thumbnailPerc}%` }}></div></div>
                )}
              </div>
              <div className="flex-col w-40 h-40 bg-white rounded-md shadow-2xl">
                <div className="flex flex-col justify-start mx-2 text-sm font-semibold">
                  <div className="pt-2 text-xs font-bold">Upload Model File :</div>
                  <div className="h-[1px] min-w-full bg-[#959595a0]" />
                </div>
                <div className="flex mx-2 items-center justify-center h-[110px]">
                  <label htmlFor="model" className="cursor-pointer">
                    <img alt="upload" src={unitysceen} className="w-16 h-16" />
                  </label>
                  <input className="hidden" id="model" type="file" onChange={(e) => setModel(e.target.files[0])} />
                </div>
                <div className="flex flex-col justify-end mx-2 text-sm font-semibold">
                  <div className="h-[2px] min-w-full bg-[#959595a0]" />
                  <div className="text-center text-[#959595a0] text-xs truncate px-1">
                    {model?.name || editPopup.modelname}
                  </div>
                </div>
                {modelPerc > 0 && (
                  <div className="w-full h-2"><div className="h-full rounded-b-md bg-opacity-70 bg-[#FFB257]" style={{ width: `${modelPerc}%` }}></div></div>
                )}
              </div>
            </div>
            <div className="flex flex-col items-start gap-4">
              <div className="flex items-center justify-end py-2">
                <label className="flex items-end px-3 font-semibold">Model name :</label>
                <input disabled value={model ? model.name : editPopup.modelname} type="text" className="w-[163px] text-center mb-2 border-b border-gray-500 outline-none" />
              </div>
              <div className="flex items-center justify-end py-3">
                <label className="flex items-end px-3 font-semibold">Model Type:<span className="ml-1 text-red-500">*</span></label>
                <select className="w-[163px] text-center mb-2 border-b border-gray-500 outline-none" value={which_type} onChange={(e) => setWhich_type(e.target.value)}>
                  <option value="2D">2D</option>
                  <option value="3D">3D</option>
                </select>
              </div>
              <div className="flex items-center justify-end py-3">
                <label className="flex items-end px-3 font-semibold">Platform:<span className="ml-1 text-red-500">*</span></label>
                <select className="w-[163px] text-center mb-2 border-b border-gray-500 outline-none" value={platform} onChange={(e) => setPlatform(e.target.value)}>
                  <option value="Android">Android</option>
                  <option value="iOS">iOS</option>
                </select>
              </div>
              <div ref={categoryDropdownRef} className="relative flex items-center justify-start py-3 cursor-pointer">
                <label className="flex items-end px-3 font-semibold">Category :<span className="ml-1 text-red-500">*</span></label>
                <div className="flex pb-1 border-b border-gray-500 outline-none ">
                  <input type="text" value={category} placeholder="Select category" className="w-[140px]" style={{ border: "none", outline: "none", textAlign: "center" }} readOnly />
                  <RiArrowDownSFill onClick={() => setDropdownOpen(!dropdownOpen)} className="text-xl" />
                  {dropdownOpen && (
                    <div style={{ zIndex: "100" }} className="absolute top-9 left-25 bg-white shadow-xl rounded-md border w-60 overflow-y-auto max-h-60 modelscroll">
                      <div className="p-2">
                        <div className="flex items-center border rounded-md px-1 mb-2">
                          <IoIosSearch className="text-gray-400" />
                          <input type="text" placeholder="Search..." onChange={(e) => { const term = e.target.value.toLowerCase(); setFilterCategoryData(uniqueCategories.filter(c => c.category.toLowerCase().includes(term)))}} className="w-full p-1 outline-none"/>
                        </div>
                        <div className="flex items-center border rounded-md px-1">
                          <input type="text" value={customCategory} onChange={(e) => setCustomCategory(e.target.value)} placeholder="Add new category" className="w-full p-1 outline-none"/>
                          <button type="button" onClick={() => { if (customCategory.trim()) { handleCategorySelect({ category: customCategory.trim() }); setCustomCategory(""); }}} className="bg-gray-200 px-2 py-0.5 rounded-md text-sm">Add</button>
                        </div>
                      </div>
                      <ul className="py-1">
                        {(filterCategoryData.length > 0 ? filterCategoryData : uniqueCategories).map((item, idx) => (
                          <li key={idx} onClick={() => handleCategorySelect(item)} className="px-3 py-2 cursor-pointer hover:bg-gray-100">{item.category}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div ref={companyDropdownRef} className="relative flex items-center justify-start py-3 cursor-pointer">
                <label className="flex items-end px-3 font-semibold">Company Name :</label>
                <div className="flex pb-1 border-b border-gray-500 outline-none">
                  <input type="text" value={companyname} placeholder="Select company" className="w-[140px]" style={{ border: "none", outline: "none", textAlign: "center" }} readOnly />
                  <RiArrowDownSFill onClick={() => setDropdownOpenCompany(!dropdownOpenCompany)} className="text-xl" />
                  {dropdownOpenCompany && (
                    <div style={{ zIndex: "100" }} className="absolute top-9 left-25 bg-white shadow-xl rounded-md border w-60 overflow-y-auto max-h-60 modelscroll">
                        <div className="p-2">
                        <div className="flex items-center border rounded-md px-1 mb-2">
                          <IoIosSearch className="text-gray-400" />
                          <input type="text" placeholder="Search..." onChange={(e) => { const term = e.target.value.toLowerCase(); setFilterCompanyData(uniqueCompanynames.filter(c => c.companyname.toLowerCase().includes(term)))}} className="w-full p-1 outline-none"/>
                        </div>
                        <div className="flex items-center border rounded-md px-1">
                          <input type="text" value={customCompanyname} onChange={(e) => setCustomCompanyname(e.target.value)} placeholder="Add new company" className="w-full p-1 outline-none"/>
                          <button type="button" onClick={() => { if (customCompanyname.trim()) { handleCompanyNameSelect({ companyname: customCompanyname.trim() }); setCustomCompanyname(""); }}} className="bg-gray-200 px-2 py-0.5 rounded-md text-sm">Add</button>
                        </div>
                      </div>
                      <ul className="py-1">
                        {(filterCompanyData.length > 0 ? filterCompanyData : uniqueCompanynames).map((item, idx) => (
                          <li key={idx} onClick={() => handleCompanyNameSelect(item)} className="px-3 py-2 cursor-pointer hover:bg-gray-100">{item.companyname}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
              <div ref={dropdownRef} className="relative flex items-center justify-end py-3">
                <label className="flex items-end px-3 font-semibold">Model Assign to :</label>
                <div className="w-[163px] text-center flex items-start mb-2 pb-1 text-black border-b border-gray-500 outline-none">{access.length} / {user.length} selected</div>
                <div onClick={() => setIsDropdownOpenfilter(!isDropdownOpenfilter)} className="absolute bottom-6 right-1 p-[0.2px] bg-white shadow-sm rounded-md cursor-pointer">
                  <RiArrowDownSFill className="text-xl" />
                </div>
                {isDropdownOpenfilter && (
                  <div className="absolute top-9 left-36 bg-white shadow-xl rounded-md border w-60 z-50">
                    <ul className="overflow-y-auto h-[190px] p-2">
                      <li className="p-1">
                        <div className="flex items-center border rounded-md px-1">
                          <IoIosSearch className="text-gray-400" />
                          <input type="text" placeholder="Search by email..." value={searchUserTerm} onChange={(e) => setSearchUserTerm(e.target.value)} className="w-full p-1 outline-none"/>
                        </div>
                      </li>
                      <li className="flex items-center justify-between px-2 py-1 border-b">
                        <span className="font-semibold">Select All</span>
                        <input type="checkbox" checked={selectAllChecked} onChange={handleSelectAllChanged} className="w-4 h-4 text-red-500 rounded form-checkbox"/>
                      </li>
                      {filteredUsers.map((item) => (
                          <li key={item._id} className="flex items-center justify-between px-2 py-1 border-b">
                              <span className="text-sm">{item.email}</span>
                              <input type="checkbox" checked={access.includes(item.email)} onChange={() => handleCheckboxChanged(item.email)} className="w-4 h-4 text-red-500 rounded form-checkbox"/>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
              <div className="flex items-center justify-end py-3">
                <label className="flex items-end px-3 font-semibold">Uploaded By :</label>
                <input disabled value={editPopup.createdby} type="text" className="w-[163px] text-center mb-2 border-b border-gray-500 outline-none" />
              </div>
            </div>
          </div>
          <div className="flex justify-center p-1 mt-3 space-x-12 button-container pt-5">
            <button type="button" onClick={handleCloseEdit} className="flex-shrink-0 w-24 py-2 text-black bg-white shadow-md rounded-md">Cancel</button>
            <button type="submit" className="w-24 py-2 text-white rounded-md" style={{ background: "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)" }}>Update</button>
          </div>
        </form>
      </div>
    </div>
  );
}